import React, { Component } from 'react';

import ZigZag from './ZigZag';

export default class ProjectContent extends Component {
	render() {
		const { children, altTitle, enjeux, mecanique, subtitle } = this.props;
		let title = ''

		if(enjeux) {
			title = 'Les enjeux de l\'application web'
		} else if (mecanique) {
			title = 'Mécanique de l\'application'
		} else {
			title = altTitle
		}

		return (
			<div>
				<section className="bloc-texte">
					<ZigZag />
					<h2>{title}</h2>
					<ZigZag />
				</section>
				<section className="bloc-texte right">
					{subtitle ? (
						<p className="text-detail subtitle">
							<strong>{subtitle}</strong>
						</p>
					) : null}
				{children}
				</section>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/ProjectContent.js